/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TreatmentPrescription } from '../../models/treatment-prescription';

export interface GetTreatmentPrescriptions$Params {
  treatmentId: string;
  prescriptionNumberId?: string;
}

export function getTreatmentPrescriptions(http: HttpClient, rootUrl: string, params: GetTreatmentPrescriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<TreatmentPrescription>> {
  const rb = new RequestBuilder(rootUrl, getTreatmentPrescriptions.PATH, 'get');
  if (params) {
    rb.query('treatmentId', params.treatmentId, {});
    rb.query('prescriptionNumberId', params.prescriptionNumberId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TreatmentPrescription>;
    })
  );
}

getTreatmentPrescriptions.PATH = '/api/prescriptions/';
